<template>
  <slot v-if="visible" :permissions="permissions"></slot>
</template>

<script setup lang="ts">
import { useLoginStore } from '@/store'

const props = defineProps({
  permission: {
    type: String,
    default: ''
  }
})
const { permissions } = useLoginStore()

const visible = computed(() => {
  const { permission } = props
  if (!permission) return true
  return permissions.includes(permission)
})
</script>

<style lang="scss" scoped></style>
